var map = {
	"./arrow-small.svg": "34a9",
	"./bg1.png": "852b",
	"./bg2.png": "028e",
	"./bg3.png": "be5e",
	"./button-arrow.svg": "df5d",
	"./button-bg.png": "3740",
	"./card-arrow.svg": "0b2f",
	"./close.svg": "bf37",
	"./experience--xxl.jpg": "78a2",
	"./experience.jpg": "dc81",
	"./fb-gradient.svg": "da2b",
	"./fb.svg": "a39e",
	"./insta-gradient.svg": "217d",
	"./insta.svg": "598a",
	"./intro-background.jpg": "d3a5",
	"./items/bianco-xxl.png": "de47",
	"./items/bianco.png": "9a48",
	"./items/mojito-xxl.png": "fd6d",
	"./items/mojito.png": "83dc",
	"./items/moscato-xxl.png": "1ef5",
	"./items/moscato.png": "101f",
	"./items/passionfruit-grapefruit-xxl.png": "855b",
	"./items/passionfruit-grapefruit.png": "3dde",
	"./items/passionfruit-pineapple-xxl.png": "99fe",
	"./items/passionfruit-pineapple.png": "3dcb",
	"./items/pomegranat-grapefruit-xxl.png": "9936",
	"./items/pomegranat-grapefruit.png": "80e7",
	"./items/rose-xxl.png": "29a1",
	"./items/rose.png": "cf9e",
	"./items/sangria-bianco-xxl.png": "fe2c",
	"./items/sangria-bianco.png": "6f56",
	"./items/sangria-tinto-xxl.png": "f9ac",
	"./items/sangria-tinto.png": "6e6f",
	"./items/strawberry-raspberry-xxl.png": "2858",
	"./items/strawberry-raspberry.png": "b6d1",
	"./items/vermouth-bianco-xxl.png": "37e3",
	"./items/vermouth-bianco.png": "55a9",
	"./items/vermouth-rosso-xxl.png": "24b9",
	"./items/vermouth-rosso.png": "fe42",
	"./items/violetto-xxl.png": "4d5c",
	"./items/violetto.png": "eaf8",
	"./logo-horizontal.png": "85eb",
	"./logo.png": "cf05",
	"./low-alcohol.jpg": "5d8f",
	"./menu-hover.svg": "ec3a",
	"./natural-ingredients--xxl.jpg": "49d1",
	"./natural-ingredients.jpg": "018c",
	"./naturals.jpg": "8c39",
	"./quality-control--xxl.jpg": "568a",
	"./quality-control.jpg": "bad3",
	"./slider-next--dark.svg": "2d37",
	"./slider-next.svg": "fe56",
	"./slider-prev--dark.svg": "18e7",
	"./slider-prev.svg": "0337",
	"./tasty.jpg": "9f0d",
	"./video-dummy.jpg": "80d1",
	"./vidos.mp4": "63da",
	"./vidos.ogg": "43d2",
	"./vk-gradient.svg": "3d69",
	"./vk.svg": "330c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";